/** Possible states of access to microphone */
export var UserMediaState;
(function (UserMediaState) {
    /** User has not responded to the broswer's prompt for microphone access */
    UserMediaState[UserMediaState["Pending"] = 0] = "Pending";
    /** User has granted access to their microphone */
    UserMediaState[UserMediaState["Available"] = 1] = "Available";
    /** User has denied access to their microphone */
    UserMediaState[UserMediaState["Unavailable"] = 2] = "Unavailable";
})(UserMediaState || (UserMediaState = {}));
/** Possible states of the OVR tool */
export var ToolState;
(function (ToolState) {
    ToolState[ToolState["Ready"] = 0] = "Ready";
    ToolState[ToolState["Recording"] = 1] = "Recording";
    ToolState[ToolState["Paused"] = 2] = "Paused";
    ToolState[ToolState["Deleting"] = 3] = "Deleting";
    ToolState[ToolState["Previewing"] = 4] = "Previewing";
    ToolState[ToolState["Uploaded"] = 5] = "Uploaded";
})(ToolState || (ToolState = {}));
/** Possible states of the the wavesurfer microphone plugin*/
export var RealtimeWaveState;
(function (RealtimeWaveState) {
    RealtimeWaveState[RealtimeWaveState["Loading"] = 0] = "Loading";
    RealtimeWaveState[RealtimeWaveState["Unsupported"] = 1] = "Unsupported";
    RealtimeWaveState[RealtimeWaveState["Supported"] = 2] = "Supported";
})(RealtimeWaveState || (RealtimeWaveState = {}));
